module.exports = __webpack_public_path__ + "static/walnutcreek-3722e6021ed126d5302db03ae676db92.jpg";